/** Signature / `title` options for Shengen Admission letter. */
export const listShengenAdmissionSignatures: Record<string, string> = {
  "Admission Letter": "Admission Letter",
  "Conditional Admission Letter": "Conditional Admission Letter",
};

export const SHENGEN_ADMISSION_SIGNATURE_LABELS = Object.keys(listShengenAdmissionSignatures);
